import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { loadSingleSite } from "../../../Site/SiteList/SiteList.actionCreators";

const SiteMenu = (props) => {
  const { t, handleNavItemClick, handleContextMenu } = props;
  const params = useParams();
  const siteId = parseInt(params.id, 10);
  const dispatch = useDispatch();

  const [siteData, setSiteData] = useState([]);
  const siteInfo = useSelector(
    (state) => state.siteList.byId[parseInt(params.id)]
  );

  const selectedSiteData = useSelector((state) => state.siteList.selectedSite);

  const fetchSiteInfo = () => {
    if (!Number.isInteger(siteId) || siteId <= 0) {
      return;
    }
    dispatch(
      loadSingleSite({
        siteId,
      })
    );
  };

  useEffect(() => {
    if (siteInfo === undefined) {
      fetchSiteInfo();
    }
  }, [siteInfo, params.id]);

  useEffect(() => {
    if (
      siteInfo !== undefined &&
      parseInt(siteId, 10) === parseInt(siteInfo.id, 10)
    ) {
      setSiteData(siteInfo);
    }
    if (
      selectedSiteData !== null &&
      parseInt(siteId, 10) === parseInt(selectedSiteData.id, 10)
    ) {
      setSiteData(selectedSiteData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteInfo, selectedSiteData]);

  return (
    <div className="sub-list">
      <ul>
        <li
          data-link={`/site/view/${params.id}/general-info`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "general-info" ? "active" : ""}
        >
          {t("MENU_SITES_GENERAL_INFORMATION")}
        </li>
        <li
          data-link={`/site/view/${params.id}/contacts`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "contacts" ? "active" : ""}
        >
          {t("MENU_SITES_CONTACTS")}
        </li>
        {siteData.koStatus !== undefined &&
          parseInt(siteData.koStatus, 10) !== 0 &&
          siteData.koStatus !== null &&
          siteData?.platformCountry?.needKickoff === 1 &&
          siteData?.needKickoff === 1 && (
            <li
              data-link={`/site/view/${params.id}/kickoff`}
              onClick={handleNavItemClick}
              onContextMenu={handleContextMenu}
              className={params.path === "kickoff" ? "active" : ""}
            >
              {t("MENU_SITES_KICKOFF")}
            </li>
          )}

        <li
          data-link={`/site/view/${params.id}/enquiry`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={
            params.path === "enquiry" ||
            params.path?.startsWith("enquiry-view")
              ? "active"
              : ""
          }
        >
          {t("MENU_SITES_ENQUIRIES")}
        </li>
        <li
          data-link={`/site/view/${params.id}/analytical-notes`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "analytical-notes" ? "active" : ""}
        >
          {t("MENU_SITES_ANALYTICAL_NOTES")}
        </li>
        <li
          data-link={`/site/view/${params.id}/documents`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "documents" ? "active" : ""}
        >
          {t("MENU_SITES_DOCUMENTS")}
        </li>
        <li
          data-link={`/site/view/${params.id}/quotes`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={
            params.path === "quotes" || params.path?.startsWith("quote-")
              ? "active"
              : ""
          }
          // className={params.path === "quotes" ? "active" : ""}
        >
          {t("MENU_SITES_QUOTES")}
        </li>
        {[3, 12, 13, 14, 15].indexOf(parseInt(siteData.status, 10)) !== -1 && (
          <li
            data-link={`/site/view/${params.id}/purchase-orders`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={params.path === "purchase-orders" ? "active" : ""}
          >
            {t("MENU_SITES_PURCHASE_ORDERS")}
          </li>
        )}
        <li
          data-link={`/site/view/${params.id}/meeting-reports`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "meeting-reports" ? "active" : ""}
        >
          {t("MENU_SITES_MEETING_REPORTS")}
        </li>
        {[13, 14, 15].indexOf(parseInt(siteData.status, 10)) !== -1 && (
          <>
            <li
              data-link={`/site/view/${params.id}/planning`}
              onClick={handleNavItemClick}
              onContextMenu={handleContextMenu}
              className={params.path === "planning" ? "active" : ""}
            >
              {t("MENU_SITES_PLANNING")}
            </li>
            <li
              data-link={`/site/view/${params.id}/summary`}
              onClick={handleNavItemClick}
              onContextMenu={handleContextMenu}
              className={params.path === "summary" ? "active" : ""}
            >
              {t("MENU_SITES_SUMMARIES")}
            </li>
            <li
              data-link={`/site/view/${params.id}/dispute`}
              onClick={handleNavItemClick}
              onContextMenu={handleContextMenu}
              className={params.path === "dispute" ? "active" : ""}
            >
              {t("MENU_SITES_DISPUTES")}
            </li>
          </>
        )}
        {[12, 13, 14, 15].indexOf(parseInt(siteData.status, 10)) !== -1 && (
          <>
            <li
              data-link={`/site/view/${params.id}/invoices`}
              onClick={handleNavItemClick}
              onContextMenu={handleContextMenu}
              className={params.path === "invoices" ? "active" : ""}
            >
              {t("MENU_SITES_INVOICES")}
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

SiteMenu.propTypes = {
  t: PropTypes.func.isRequired,
  handleNavItemClick: PropTypes.func.isRequired,
  handleContextMenu: PropTypes.func.isRequired,
};

export default withTranslation()(SiteMenu);
